import * as React from 'react';
import { Text } from '@chakra-ui/react';

export const NotFound = () => {
    return (
        <Text>NotFound</Text>
    )
}